import { ambientTemperature } from 'constants/constants';
import { TransportationDetails } from 'models/Farmbox/transportation.model';

export const stage2InitialData = async (
  commodityId: string | undefined,
  fetchTransportationData: (pathParams: {
    commodityId?: string;
  }) => Promise<TransportationDetails | undefined>
) => {
  const initialValues =
    (await fetchTransportationData({ commodityId })) ??
    new TransportationDetails();
  const defaultValues =
    initialValues?.fertilizers || initialValues?.packagings
      ? Object.assign(new TransportationDetails(), initialValues)
      : new TransportationDetails();

  defaultValues.fertilizers?.forEach(item => {
    item.temperatureControl ??= ambientTemperature;
    item.children?.forEach((children)=>{
      children.temperatureControl ??= ambientTemperature;
    })
  });
  return defaultValues;
};
